import { useEffect } from "react";
import useHttpHook from "../../../Hooks/HttpHook";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import CreateEventFormTab from "./CreateEventFormTab";
import EventDetailsForm from "./EventDetailsForm";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { showErrorToast } from "../../../utils/notify";
const EventDetail = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const location = useLocation();
  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="eventCreationFrom">
        <CreateEventFormTab
          Id="details"
          isOnlyTicket={location?.state?.isOnlyTickets ? true : false}
        />
        <EventDetailsForm
          isOnlyTicket={location?.state?.isOnlyTickets ? true : false}
        />
      </div>
    </MainComponentWrapper>
  );
};

export default EventDetail;
